import * as tf from '@tensorflow/tfjs';
import BoardModel from './boardModel';

class Encoder {
  encodeBoardModel(boardModel) {
    const boardSize = boardModel.boardSize;
    const black = tf.buffer([boardSize, boardSize]);
    const white = tf.buffer([boardSize, boardSize]);
    // buffer: 0-18, boardModel: 1-19
    for (let y = 0; y < boardSize; y++) {
      for (let x = 0; x < boardSize; x++) {
        let state = boardModel.getState(x + 1, y + 1);
        if (state === BoardModel.BLACK) {
          black.set(1.0, y, x); // swap x,y
        } else if (state === BoardModel.WHITE) {
          white.set(1.0, y, x); // swap x,y
        }
      }
    }
    return [black.toTensor(), white.toTensor()];
  }
}

export default Encoder;